import resolvers from 'store/resolvers';

const defaultClientData = {
  locale: 'en-GB',
  isLoggedIn: false,
  searchParams: {
    __typename: 'SearchParams',
    outboundDate: '',
    inboundDate: '',
    origin: '',
    destination: '',
    returningOrigin: '',
    returningDestination: '',
    adults: 0,
    adults12To15: 0,
    adults16Plus: 0,
    children: 0,
    children4Only: 0,
    children5To11: 0,
    infants: 0,
    youths: 0,
    seniors: 0
  },
  passengerDetails: [],
  billingDetails: {
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    city: '',
    postalCode: '',
    countryCode: '',
    email: '',
    phoneCountryCode: '',
    phoneNumber: '',
    __typename: 'BillingDetails'
  }
};

const typeDefs = `
    input ReceiptInput {
      aId: String!
      amount: String!
      authMethod: String!
      bookingReference: String!
      cardType: String!
      currency: String!
      customerName: String!
      customerPan: String!
      issueNumber: String!
      merchantId: String!
      paymentDate: String!
      paymentTime: String!
      receiptNumber: String!
      terminalId: String!
    }

    enum Locale {
      en-GB
      fr-FR
      nl-NL
    }

    type TicketsWithCompensation {
      ticketNumber: String!
      status: String!
      method: String
    }

    type Mutation {
      printTickets(printCommands: [String!]): PrintStatus
      printReceipt(receiptInput: ReceiptInput!): PrintStatus
      printTicketsAtb(bookingReference: String! itemRefs: [String]): [PrintStatus]
      updateProductsWithSalesforceStatus(tickets: [TicketsWithCompensation!]!)
    }

    type Query {
      locale: Locale
      passengerDetails: [Passenger]
      searchParams: SearchParams
      billingDetails: BillingDetails
      isLoggedIn: Boolean
    }

    emum PrintStatus {
      PRINTER_SUCCESS
    }

    type Fare {
      offlineFee: OfflineFee
    }

    type OfflineFee {
      price: Float
      tariffCode: String
      passengerId: String
      code: String
      name: String
    }

    type User {
      currencies: [Currency]
      canOverrideFees: Boolean
      canEditPassengers: Boolean
      canHaveGroupBookings: Boolean
      canHaveStandardBookings: Boolean
      canAddSpecialAssistanceToBooking: Boolean
    }

    type Booking {
      displayStatus: String
      arePassengersEditable: Boolean
      allBookingItems: [BookingItem]
    }

    type Currency {
      name: String
    }

    type UnformattedPhoneNumber {
      countryCode: String
      number: String
    }

    type Passenger {
      birthDate: String
      countryCode: String
      email: String
      firstName: String
      paxId: String
      lastName: String
      unformattedPhoneNumber: [UnformattedPhoneNumber]
      loyaltyNumber: String
      type: String
    }

    type SearchParams {
      outboundDate: String
      inboundDate: String
      origin: String
      destination: String
      returningOrigin: String
      returningDestination: String
      adults: Int
      adults12To15: Int
      adults16Plus: Int
      children: Int
      children4Only: Int
      children5To11: Int
      infants: Int
      youths: Int
      seniors: Int
    }

    type BillingDetails {
      firstName: String
      lastName: String
      addressLine1: String
      addressLine2: String
      addressLine3: String
      city: String
      postalCode: String
      countryCode: String
      email: String
      phoneCountryCode: String
      phoneNumber: String
    }

    type Leg {
      bookingItems: [BookingItem]
      temporarilyCancelledBookingItems: [BookingItem]
      activeBookingItems: [BookingItem]
      productSummaries: [ProductSummary]
    }

    type BookingItem {
      mealCode: String
      status: String
      refundMethod: String
      isPrrAttempted: Boolean
      isSeatEditable: Boolean
      isMealEditable: Boolean
    }

    type ProductSummary {
      name: String
      passengerType: String
      code: String
      total: Float
      quantity: Int
      price: Float
    }

    type Profile {
      subscriptionsHash: String
    }
  `;

export { defaultClientData, typeDefs, resolvers };
